import React from "react"
import { IButton, ILink, IMediaAsset, Maybe } from "../../../gatsby-graphql"
import SlickSlider from "react-slick"
import { Button } from "../../ui"
import { ButtonType } from "../../ui/button/button-elements"
import {
  SlideContentInfo,
  ButtonsList, ButtonWrapper,
  Description,
  FullSizeSliderWrapper,
  FullSizeSlideWrapper,
  SlideContentWrapper,
  SlideHeaderLogo,
  Title
} from "./full-size-slider-elements"

interface FullSizeSlideProps {
  title: string,
  description: string,
  header: IMediaAsset,
  background: IMediaAsset,
  backgroundLaptop: IMediaAsset,
  backgroundTablet: IMediaAsset,
  backgroundMobile: IMediaAsset,
  buttons: Array<Maybe<IButton>>,
  gradientStart: string,
  gradientEnd: string
}

interface FullSizeSliderProps {
  locale?: string
  data: {
    autoscroll?: boolean,
    slides: Array<FullSizeSlideProps>
  },
}

export default function FullSizeSlider({ data, locale }: FullSizeSliderProps) {
  return <FullSizeSliderWrapper>
    <SlickSlider
      arrows={true}
      dots={true}
      autoplay={false}
    >
      {data.slides.map((slide, index) => <FullSizeSlide slide={slide} locale={locale} key={index} />)}
    </SlickSlider>
  </FullSizeSliderWrapper>
}

function FullSizeSlide({ slide, locale }: { slide: FullSizeSlideProps, locale?: string }) {
  return <FullSizeSlideWrapper gradientStart={slide.gradientStart} gradientEnd={slide.gradientEnd}>
    <SlideContentWrapper
      imgSrc={slide.background.url || ""}
      imgSrcLaptop={slide.backgroundLaptop?.url || ""}
      imgSrcTablet={slide.backgroundTablet?.url || ""}
      imgSrcMobile={slide.backgroundMobile?.url || ""}
    >
      <SlideContentInfo>
        {slide.header && slide.header.url &&
          <SlideHeaderLogo alt={slide.title} src={slide.header.url} />}
        <Title>{slide.title}</Title>
        <Description>{slide.description}</Description>
        <ButtonsList>
          {slide.buttons.map((button, index) => <ButtonWrapper key={index}>
            <Button
              type={button?.type as ButtonType}
              link={button?.link as ILink}
              locale={locale}
            >{button?.name}</Button>
          </ButtonWrapper>)}
        </ButtonsList>
      </SlideContentInfo>
    </SlideContentWrapper>
  </FullSizeSlideWrapper>
}
